import type { TraceGridRow } from "./types";

import { createGridSelectionHelpers } from "@/components/ui/ag-grid-table";

export const getTraceRowId = (data: TraceGridRow | undefined): string | null => {
  const raw = data?.trace_id;
  if (!raw) {
    return null;
  }
  return String(raw);
};

const helpers = createGridSelectionHelpers<string, TraceGridRow>(getTraceRowId);

export const { collectLoadedRowIds, collectCurrentPageRowIds, collectLoadedSelectedRowIds } =
  helpers;
